<template>
  <Header>
    <div class="screen-1">
      <div class="container container-1375">
        <div class="pl-md-5 pr-md-5 pl-lg-0 pr-lg-0">
          <div class="row">
            <div class="col-12 col-lg-6 col-lg-6-custom">
              <p class="text-uppercase caption">{{ $t(locale.s1.title) }}</p>
              <h1 class="title-light title-large pl-0 pt-4">{{ $t(locale.s1.motto) }}</h1>
              <p class="text-block text-white opacity pt-4 pr-sm-5">{{ $t(locale.s1.text) }}</p>
            </div>
            <div class="col-12 col-lg-6 mt-sm-4 mt-lg-0 d-none d-sm-block screen-1-img-wrapper">
              <img class="img-fluid" src="/img/screen-1-v.jpg" :alt="$t(locale.s1.motto)">
            </div>
          </div>
        </div>
      </div>
    </div>
  </Header>
</template>

<script>
import Header from "@/components/header/Header";
import stringsKeys from "@/i18n/strings.json";

export default {
  name: 'ScreenMotto',
  methods: {},
  components: {
    Header,
  },
  data: () => {
    return {
      locale: stringsKeys,
    }
  }
}
</script>

<style lang="scss">
@import "~bootstrap";
@import "src/scss/colors";

.screen-1 {
  background-color: $black;
  padding-top: 20px;
  padding-bottom: 40px;
  @media (min-width: 576px) {
    padding-top: 100px;
    padding-bottom: 135px;
  }
  @media (min-width: 992px) {
    background-color: transparent;
    padding-top: 137px;
  }
  @media (min-width: 1920px) {
    padding-top: 187px;
    height: 715px;
  }

  .col-lg-6-custom {
    @media (min-width: 1920px) {
      max-width: 545px;
      margin-left: auto;
      margin-right: 110px;
    }
  }

  .screen-1-img-wrapper {
    @media (min-width: 1920px) {
      width: auto;
      max-width: 909px;
      padding: 0;
    }

    img {
      @media (min-width: 1920px) {
        width: 909px;
        max-width: none;
      }
    }
  }
}
</style>